export const LOGIN = '/api/auth/login';
export const FORGOT_PASSWORD = '/api/auth/password/sms';
export const RESET_PASSWORD = '/api/auth/password/reset';
export const GET_ME = '/api/me';
